import { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp } from '@fortawesome/pro-solid-svg-icons/faSortUp';
import { faSortDown } from '@fortawesome/pro-solid-svg-icons/faSortDown';
import moment from 'moment';

import { topGBPMinKeys } from '../../../../../../data/ukPrivateCompanyInsights';
import { checkAndRoun } from '../../../../../../helpers/topicsHelpers';
import { roundTo } from '../../../../../../helpers/helpers';
import convertPermalinkToPath from '../../../../../../helpers/urlHelpers';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const TopEquity = (props) => {
  const {
    type, selectedYear, hasChanges, previousYear, hasInsightsAccess, topSectionData,
  } = props;
  const [activeTableTab, setActiveTableTab] = useState('ytd');

  const handleTabChange = (value) => {
    setActiveTableTab(value);
  };

  return (
    <div className={cx('top-sections-outer-holder')}>
      <div className={Styles['top-sections-header']}>
        <div />
        <div
          className={cx('top-sections-header-ytd', { active: activeTableTab === 'ytd' })}
          onClick={() => handleTabChange('ytd')}
        >
          {moment().year() === selectedYear ? 'YTD' : selectedYear}
        </div>
        {hasChanges && (
          <>
            <div
              className={cx('top-sections-header-year', { active: activeTableTab === 'year' })}
              onClick={() => handleTabChange('year')}
            >
              {previousYear}
            </div>
            <div
              className={cx('top-sections-header-change', { active: activeTableTab === 'change' })}
              onClick={() => handleTabChange('change')}
            >
              Change
            </div>
          </>
        )}
      </div>
      <div className={Styles['top-sections-lists']}>
        {!hasInsightsAccess && (
          <div className={Styles['top-sections-upgrade']}>
            <div className={Styles['top-sections-upgrade-message']}>
              <Link to="/pricing">
                Upgrade to UK Insights
              </Link>
              {' '}
              to use this feature.
            </div>
          </div>
        )}
        {topSectionData.data.map((obj, i) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={`key_${i}`}
            className={cx('top-sections-list', { no_access: !hasInsightsAccess, has_changes: hasChanges })}
          >
            {!hasInsightsAccess ? (
              <div className={Styles['top-sections-list-title']}>
                Company Name
              </div>
            ) : (
              <>
                {obj[topGBPMinKeys[type].urlLink] ? (
                  <Link
                    className={Styles['top-sections-list-title']}
                    to={convertPermalinkToPath(obj[topGBPMinKeys[type].urlLink])}
                  >
                    {obj.name}
                  </Link>
                ) : (
                  <div
                    className={cx('top-sections-list-title', 'no-link')}
                  >
                    {obj.name}
                  </div>
                )}
              </>
            )}
            <div className={cx('top-sections-list-ytd', { active: activeTableTab === 'ytd' })}>
              {type === 'roi' ? (
                <>
                  {roundTo(obj[topGBPMinKeys[type].ytd] || 0, 2)}
                  %
                </>
              ) : checkAndRoun(obj[topGBPMinKeys[type].ytd] || 0, 2, true, true, true)}
            </div>
            {hasChanges && (
              <>
                <div className={cx('top-sections-list-year', { active: activeTableTab === 'year' })}>
                  {checkAndRoun(obj[topGBPMinKeys[type].year] || 0, 2, true, false)}
                </div>
                <div
                  className={cx('top-sections-list-change', {
                    positive: obj[topGBPMinKeys[type].change] > 0,
                    negative: obj[topGBPMinKeys[type].change] < 0,
                    neutral: obj[topGBPMinKeys[type].change] === 0,
                    active: activeTableTab === 'change',
                  })}
                >
                  <FontAwesomeIcon
                    icon={obj[topGBPMinKeys[type].change] >= 0 ? faSortUp : faSortDown}
                  />
                  {Number(Math.abs(obj[topGBPMinKeys[type].change]).toFixed(2))}
                  %
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopEquity;
